var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 10C18.9543 10 10 18.9543 10 30C10 41.0457 18.9543 50 30 50C41.0457 50 50 41.0457 50 30C50 18.9543 41.0457 10 30 10ZM5 30C5 16.1929 16.1929 5 30 5C43.8071 5 55 16.1929 55 30C55 43.8071 43.8071 55 30 55C16.1929 55 5 43.8071 5 30Z",
    fill: "#3CAE8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6609 21.8815C42.6929 22.7988 42.7858 24.379 41.8685 25.4109L28.5352 40.4109C28.0608 40.9447 27.3808 41.25 26.6667 41.25C25.9526 41.25 25.2726 40.9447 24.7982 40.4109L18.1315 32.9109C17.2142 31.879 17.3072 30.2988 18.3391 29.3815C19.3711 28.4642 20.9513 28.5572 21.8685 29.5891L26.6667 34.987L38.1315 22.0891C39.0488 21.0572 40.629 20.9642 41.6609 21.8815Z",
    fill: "#3CAE8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCheckmark);
export default __webpack_public_path__ + "static/media/newCheckmark.7ae8a4c6290c67f49867f162132c1d65.svg";
export { ForwardRef as ReactComponent };